<section class="footer-container">
  <mat-icon svgIcon="vspVisionLogo" [matTooltipPosition]="'left'" matTooltip="VSP Logo"></mat-icon>
  <div class="footer-text-box">
    <div style="padding-right: 20px">Reimagining how eye care <br> and eyewear are delivered</div>
    <div id="appVersion"><span class="version-styles">Version: {{appVersion}}</span>&copy; {{copyrightText}}</div>
  </div>
</section>